<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Registro de nueva cita</h1>
      </v-subheader>
      <v-row>
        <v-stepper v-model="proceso" style="max-width: 1000px; margin: auto;">
          <v-stepper-header>
            <v-stepper-step :complete="proceso > 1" step="1" editable>
              Datos de cita
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="proceso > 2"
              step="2"
              :editable="this.tipoMant ? true : false"
            >
              Elija la fecha
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :editable="this.tipoMant ? true : false">
              Elija el horario
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-container>
                <v-row align="center">
                  <v-col cols="12" sm="12" md="12" lg="6">
                    <v-select
                      :disabled="!vista.escritura || loading"
                      :items="tiposMant"
                      @change="actualizarDias()"
                      class="ma-0 pa-0"
                      dense
                      hide-details
                      hide-no-data
                      item-text="descripcion"
                      item-value="codigo"
                      label="Tipo de mantenimiento"
                      outlined
                      placeholder="Seleccione tipo"
                      v-model="tipoMant"
                    ></v-select>
                  </v-col>
                  <v-col v-if="!vista.cliente" cols="12" sm="12" md="12" lg="6">
                    <v-autocomplete
                      :disabled="!vista.escritura || loading"
                      :items="usuarios"
                      :loading="loadingUsuario"
                      :search-input.sync="busqueda"
                      @change="actualizarVehiculos()"
                      class="ma-0 pa-0"
                      dense
                      hide-details
                      hide-no-data
                      item-text="descripcion"
                      item-value="codigo"
                      label="Cliente"
                      outlined
                      placeholder="Nombre de cliente, DNI"
                      v-model="usuario"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" lg="6">
                    <v-select
                      :disabled="
                        !vista.escritura || loading || vehiculos.length == 0
                      "
                      :items="vehiculos"
                      class="ma-0 pa-0"
                      dense
                      hide-details
                      hide-no-data
                      item-text="descripcion"
                      item-value="codigo"
                      label="Vehículo"
                      outlined
                      placeholder="Seleccione vehículo"
                      v-model="vehiculo"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="6">
                    <v-text-field
                      class="input-decimal"
                      :disabled="!vista.escritura || loading"
                      dense
                      hide-details
                      label="Kilometraje"
                      outlined
                      placeholder="Ingrese kilometraje"
                      rows="2"
                      v-model="kilometraje"
                      @blur="kilometraje = numero(kilometraje)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-textarea
                      :disabled="!vista.escritura || loading"
                      dense
                      hide-details
                      label="Observaciones"
                      outlined
                      placeholder="Ingrese observaciones"
                      rows="2"
                      v-model="observaciones"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
              <div class="d-flex justify-end">
                <v-btn v-if="validarPaso1" text @click="cancelar()">
                  Cancelar
                </v-btn>
                <v-btn color="primary" @click="paso2()">
                  Continuar
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-container>
                <v-row align="center">
                  <v-col cols="12">
                    <v-date-picker
                      :allowed-dates="funAllowedDates"
                      :disabled="!vista.escritura || loading"
                      :events="funEvents"
                      :picker-date.sync="pickerDate"
                      color="primary"
                      elevation="1"
                      full-width
                      locale="es-PE"
                      v-model="fecha"
                    ></v-date-picker>
                  </v-col>
                </v-row>
              </v-container>
              <div class="d-flex justify-end">
                <v-btn text @click="cancelar()">Cancelar</v-btn>
                <v-btn text @click="paso1()">Regresar</v-btn>
                <v-btn color="primary" @click="paso3()">
                  Continuar
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-list v-if="rangos.length > 0" dense class="pa-0">
                <v-radio-group
                  dense
                  v-model="opcHorario"
                  :mandatory="false"
                  style="max-height: 300px;"
                  class="overflow-y-auto pa-0 ma-0"
                >
                  <v-list-item
                    v-for="(item, i) in rangos"
                    :key="i"
                    :disabled="!vista.escritura || loading"
                    @mousedown="clickHorario(i)"
                    @click="0"
                  >
                    <template v-slot:default>
                      {{ i + 1 }}.
                      <v-list-item-content>
                        <v-list-item-title style="text-align: center;">
                          {{ tiempo(item.hora_inicio, item.minuto_inicio) }}
                          -
                          {{ tiempo(item.hora_fin, item.minuto_fin) }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="ml-0">
                        <v-radio
                          :disabled="!vista.escritura || loading"
                          :value="i"
                        ></v-radio>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-radio-group>
              </v-list>
              <div v-else class="mb-6" style="text-align: center;">
                No se encontraron horarios disponibles
              </div>
              <div class="d-flex justify-end">
                <v-btn text @click="cancelar()">Cancelar</v-btn>
                <v-btn text @click="paso2()">Regresar</v-btn>
                <v-btn color="primary" @click="finalizar()">
                  Guardar
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!-- <v-col cols="12" sm="12" md="7" lg="5" offset-lg="1">
          <v-container>
            <v-row align="center">
              <v-col cols="12" sm="12" md="12" lg="6">
                <v-select
                  :disabled="!vista.escritura || loading"
                  :items="tiposMant"
                  @change="actualizarDias()"
                  class="ma-0 pa-0"
                  dense
                  hide-details
                  hide-no-data
                  item-text="descripcion"
                  item-value="codigo"
                  label="Tipo de mantenimiento"
                  outlined
                  placeholder="Seleccione tipo"
                  v-model="tipoMant"
                ></v-select>
              </v-col>
              <v-col v-if="!vista.cliente" cols="12" sm="12" md="12" lg="6">
                <v-autocomplete
                  :disabled="!vista.escritura || loading"
                  :items="usuarios"
                  :loading="loadingUsuario"
                  :search-input.sync="busqueda"
                  @change="actualizarVehiculos()"
                  class="ma-0 pa-0"
                  dense
                  hide-details
                  hide-no-data
                  item-text="descripcion"
                  item-value="codigo"
                  label="Cliente"
                  outlined
                  placeholder="Nombre de cliente, DNI"
                  v-model="usuario"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="12" lg="6">
                <v-select
                  :disabled="
                    !vista.escritura || loading || vehiculos.length == 0
                  "
                  :items="vehiculos"
                  class="ma-0 pa-0"
                  dense
                  hide-details
                  hide-no-data
                  item-text="descripcion"
                  item-value="codigo"
                  label="Vehículo"
                  outlined
                  placeholder="Seleccione vehículo"
                  v-model="vehiculo"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6">
                <v-text-field
                  class="input-decimal"
                  :disabled="!vista.escritura || loading"
                  dense
                  hide-details
                  label="Kilometraje"
                  outlined
                  placeholder="Ingrese kilometraje"
                  rows="2"
                  v-model="kilometraje"
                  @blur="kilometraje = numero(kilometraje)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-textarea
                  :disabled="!vista.escritura || loading"
                  dense
                  hide-details
                  label="Observaciones"
                  outlined
                  placeholder="Ingrese observaciones"
                  rows="2"
                  v-model="observaciones"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!vista.escritura || loading"
                    @click="guardar()"
                    class="mr-4"
                    color="primary"
                    small
                    >Guardar</v-btn
                  >
                  <v-btn
                    :disabled="!vista.escritura || loading"
                    @click="limpiar()"
                    class="mr-4"
                    color="primary"
                    small
                    >Limpiar</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="4" offset-lg="1">
          <v-row align="center">
            <v-col cols="12">
              <v-date-picker
                :allowed-dates="funAllowedDates"
                :disabled="!vista.escritura || loading"
                :events="funEvents"
                :picker-date.sync="pickerDate"
                color="primary"
                elevation="15"
                full-width
                locale="es-PE"
                v-model="fecha"
              ></v-date-picker>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12">
              <v-list>
                <v-subheader v-if="rangos.length > 0"
                  >Horarios de recepción:</v-subheader
                >
                <v-radio-group
                  v-model="opcHorario"
                  :mandatory="false"
                  style="max-height: 300px;"
                  class="overflow-y-auto"
                >
                  <v-list-item
                    v-for="(item, i) in rangos"
                    :key="i"
                    :disabled="!vista.escritura || loading"
                    @mousedown="clickHorario(i)"
                    @click="0"
                  >
                    <template v-slot:default>
                      {{ i + 1 }}.
                      <v-list-item-content>
                        <v-list-item-title style="text-align: center;"
                          >{{ tiempo(item.hora_inicio, item.minuto_inicio) }} -
                          {{
                            tiempo(item.hora_fin, item.minuto_fin)
                          }}</v-list-item-title
                        >
                      </v-list-item-content>
                      <v-list-item-action class="ml-0">
                        <v-radio
                          :disabled="!vista.escritura || loading"
                          :value="i"
                        ></v-radio>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-radio-group>
              </v-list>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
    </v-container>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
const FECHA_HOY = new Date();
FECHA_HOY.setHours(0, 0, 0, 0);
export default {
  name: "Cita",
  data: () => ({
    busqueda: null,
    fecha: "",
    loading: false,
    loadingUsuario: false,
    observaciones: "",
    kilometraje: "0",
    pickerDate: null,
    planifMes: [],
    tipoMant: null,
    tiposMant: [],
    usuario: null,
    usuarios: [],
    vehiculo: null,
    vehiculos: [],
    rangos: [],
    // rangosSelec: [],
    proceso: 1,
    opcHorario: -1,
    vista: {}
  }),
  watch: {
    async busqueda(valor) {
      let respuesta;
      try {
        this.loadingUsuario = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/BuscarUsuario?searchTerm=${valor}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.loadingUsuario = false;
      }

      this.usuarios = respuesta.data.map(x => ({
        codigo: x.username,
        descripcion: x.nombres + ", " + x.documento
      }));
    },
    pickerDate() {
      this.actualizarDias();
    },
    async fecha(valor) {
      this.actualizarRangos(valor, this.tipoMant);
    }
  },
  computed: {
    ...mapGetters(["getToken"]),
    validarPaso1() {
      return (
        this.tipoMant != null ||
        this.usuario != null ||
        this.vehiculo != null ||
        this.kilometraje != 0 ||
        this.observaciones.trim() != ""
      );
    }
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    tiempo(dia, hora) {
      let diaStr = "00" + dia;
      let horaStr = "00" + hora;
      return (
        diaStr.substr(diaStr.length - 2) +
        ":" +
        horaStr.substr(horaStr.length - 2)
      );
    },
    numero(valor) {
      let numero = parseFloat(valor);

      if (isNaN(numero) || numero < 0) {
        numero = 0;
      }

      return numero.toFixed(0);
    },
    clickHorario(idx) {
      this.opcHorario = idx;
    },
    paso1() {
      this.proceso = 1;
    },
    paso2() {
      if (this.tipoMant == null || this.tipoMant == "") {
        this.showAlerta2({
          mensaje: "Por favor, seleccione un tipo de mantenimiento",
          tipo: 3
        });
        return;
      }
      this.proceso = 2;
    },
    paso3() {
      if (this.fecha == "") {
        this.showAlerta2({
          mensaje: "Por favor, seleccione un fecha para su cita",
          tipo: 3
        });
        return;
      }

      const planif = this.planifMes.find(x => x.fecha_formato == this.fecha);
      console.log(planif);
      if (planif == undefined || planif.estado != "A") {
        this.showAlerta2({
          mensaje: "Fecha inválida, por favor seleccione otra",
          tipo: 3
        });
        return;
      }

      if (
        planif.tipo_mant_x_fecha.maximo - planif.tipo_mant_x_fecha.registrado <=
        0
      ) {
        this.showAlerta2({
          mensaje: "No existen citas disponibles para este día",
          tipo: 3
        });
        return;
      }

      this.proceso = 3;
    },
    async finalizar() {
      if (this.opcHorario == -1) {
        this.showAlerta2({
          mensaje: "Por favor, seleccione un horario",
          tipo: 3
        });
        return;
      }
      if (await this.guardar()) {
        this.limpiar();
        this.proceso = 1;
      }
    },
    cancelar() {
      this.limpiar();
      this.proceso = 1;
    },
    async actualizarRangos(fecha, tipoMant) {
      if (tipoMant == null || fecha == null) {
        this.rangos = [];
        return;
      }
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/planificacion/ListarRangos?fecha=${fecha}&tipoMant=${tipoMant}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.rangos = respuesta.data;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=CITA`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vista = respuesta.data;
    },
    async actualizarDias() {
      if (this.tipoMant == null || this.tipoMant == "") {
        return;
      }

      const fecha = this.pickerDate + "-01";

      let respuesta;

      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/planificacion/ListarPlanificacioMes?tipoMant=${this.tipoMant}&fecha=${fecha}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.planifMes = respuesta.data;
      this.actualizarRangos(this.fecha, this.tipoMant);
    },
    async actualizarVehiculos() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ListarVehiculos?cliente=${this.vista.cliente}&username=${this.usuario}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vehiculos = respuesta.data.map(x => ({
        codigo: x.placa,
        descripcion: `${x.placa} - ${x.serie}`
      }));
    },
    funEvents(date) {
      const planif = this.planifMes.find(x => x.fecha_formato == date);

      if (planif != undefined && planif.estado == "A") {
        if (
          planif.tipo_mant_x_fecha.maximo -
            planif.tipo_mant_x_fecha.registrado >
          0
        ) {
          return ["light-green accent-3"];
        } else {
          return ["red accent-3"];
        }
      }
      return false;
    },
    funAllowedDates(date) {
      const planif = this.planifMes.find(x => x.fecha_formato == date);
      return planif != undefined && planif.estado == "A";
    },
    async guardar() {
      let rango = this.rangos.find((val, idx, arr) => idx == this.opcHorario);

      const params = {
        cliente: this.vista.cliente,
        nuevo: true,
        fecha: this.fecha,
        placa: this.vehiculo,
        usuario_cliente: {
          username: this.usuario
        },
        tipo_mantenimiento: {
          codigo: this.tipoMant
        },
        observaciones: this.observaciones,
        kilometraje: this.kilometraje,
        rango: rango
      };

      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/Guardar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return false;
      } finally {
        this.loading = false;
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        return true;
      }

      return false;
    },
    limpiar() {
      this.planifMes = [];
      this.tipoMant = null;
      this.vehiculo = null;
      this.vehiculos = [];
      this.usuario = null;
      this.usuarios = [];
      this.observaciones = "";
      this.kilometraje = "0";
      this.opcHorario = -1;
      this.fecha = new Date().toISOString().substr(0, 10);

      if (this.vista.cliente) {
        this.actualizarVehiculos();
      }
    },
    async listarMantenimientos() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/config/ListarTiposMant",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      this.tiposMant = respuesta.data;
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    await this.loadVista();
    if (this.vista.cliente) {
      this.actualizarVehiculos();
    }
    this.fecha = FECHA_HOY.toISOString().substr(0, 10);
    this.listarMantenimientos();
  }
};
</script>

<style>
</style>
